/** @format */

import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { signOutFetch } from 'services/auth/operation'

import styles from './toolbar.module.css'

export const Toolbar = memo(() => {
  const dispatch = useDispatch()

  const handleLogout = () => dispatch(signOutFetch())

  return (
    <div className={styles.wrapper}>
      <div className={styles.titles}>
        <NavLink activeClassName={styles.isActive} to="/git" className={styles.title} style={{ color: '#ffffff' }}>
          GIT
        </NavLink>
        <NavLink activeClassName={styles.isActive} to="/html" className={styles.title} style={{ color: '#ffffff' }}>
          HTML/СSS
        </NavLink>
        <NavLink activeClassName={styles.isActive} to="/js" className={styles.title} style={{ color: '#ffffff' }}>
          JAVASCRIPT
        </NavLink>
        <NavLink activeClassName={styles.isActive} to="/react" className={styles.title} style={{ color: '#ffffff' }}>
          REACT
        </NavLink>
        <NavLink activeClassName={styles.isActive} to="/redux" className={styles.title} style={{ color: '#ffffff' }}>
          REDUX
        </NavLink>
      </div>
      <p className={styles.logout} onClick={handleLogout}>
        Logout
      </p>
    </div>
  )
})
